import { render, staticRenderFns } from "./VerifyShop.vue?vue&type=template&id=3508491d&"
import script from "./VerifyShop.vue?vue&type=script&lang=js&"
export * from "./VerifyShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports